import styled from "@emotion/styled";

export const WrapperErrorPageStyled = styled.div`
  height: 100vh;
  position: relative;
  padding: 0 32px;
`;

export const WrapperContentStyled = styled.div`
  width: 100%;
  text-align: center;
  height: calc(100% - 81px);
  display: flex;
  align-items: flex-end;
  padding-top: 38px;
  &.full-height {
    height: auto;
  }

  .content {
    min-height: calc(100% - 131px);
    width: 100%;
    h1 {
      margin: 31px 0 16px 0;
      font-size: 24px;
      line-height: 28px;
      color: ${props => props.theme.palette.text.primary};
    }
    p {
      margin-bottom: 16px;
      line-height: 24px;
      font-size: 16px;
      color:${props => props.theme.palette.text.secondary};
    }
  }
  
  img {
    width: auto;
  }
`;

export const WrapperButtonsRedirect = styled.div`
  width: calc(100%);
  button {
    font-family: Roboto;
    height: 56px;
    width: 100%;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    position: static;
    border-radius: 2px;
    border: none;
    outline: none;
    font-weight: 500;
    font-size: 18px;
    transition: all 400ms ease-in;
    margin: 0;

    &.btn--black {
      background: #000000;
      color: #ffffff;

      &:hover {
        background: #1B70C6;
        color: #ffffff;
      }
    }

    &.btn--white {
      background: #ffffff;
      color: #000000;

      &:hover {
        color: #1B70C6;
      }
    }
  }
`;

